import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_FETCH_AUDITOR_ASSETS,
} from '../../../../actions/actionTypes';

const auditorAssets = fetchReducerGenerator(
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_FETCH_AUDITOR_ASSETS
);

export default auditorAssets;
